import { useMemo } from 'react';
const callOnceWrap = (func) => {
    let isCalled = false;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
    return ((...args) => {
        if (isCalled) {
            return;
        }
        isCalled = true;
        func(...args);
    });
};
/**
 * Простая обертка на случаи, когда нужно вызвать функцию только один раз.
 * Если функция-аргумент меняется, меняется возвращаемое значение, функцию можно будет вызвать ещё раз.
 *
 * @param callback Колбэк
 * @typeParam Callback Тип колбэка
 * @returns Колбэк, который отработает только один раз
 */
export const useOnce = (callback) => {
    return useMemo(() => callOnceWrap(callback), [callback]);
};
